import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../../data/collection";

// Slim strip beneath the hero that opens the bestseller lookbook.
export default function BestsellerStrip() {
  const bs = PRODUCTS.find((p) => p.badge === "Bestseller") || PRODUCTS[0];

  const open = () => {
    // Ask Collection to open this product's lookbook
    window.dispatchEvent(new CustomEvent("keilani:openProduct", { detail: bs.id }));
    // Scroll to the card so the transition is visible
    const el = document.querySelector(`[data-testid=\"product-card-${bs.id}\"]`);
    if (el) {
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -140 });
      else el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <button
      data-testid="bestseller-strip"
      onClick={open}
      className="group relative block w-full overflow-hidden border-y border-white/10 bg-[#050505] text-left"
    >
      <div className="kln-noise" />
      <div className="relative mx-auto flex max-w-[1500px] items-center gap-4 px-6 py-4 md:gap-6 md:px-12 md:py-5">
        <div className="relative h-14 w-14 shrink-0 overflow-hidden rounded-full border border-white/15 md:h-16 md:w-16">
          <img
            src={bs.cover}
            alt={bs.name}
            className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
          />
        </div>

        <div className="flex flex-1 items-center gap-3 min-w-0">
          <span className="hidden sm:inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[var(--kln-gold)]/50 px-3 py-1 font-body text-[10px] uppercase tracking-[0.22em] text-[var(--kln-gold)]">
            <span className="text-[10px] leading-none">&#10022;</span> Bestseller
          </span>
          <p className="truncate font-body text-[11px] uppercase tracking-[0.22em] text-white/60 md:text-[12px]">
            Loved by our customers —
            <span className="ml-1.5 font-display normal-case tracking-normal text-base text-white">
              {bs.name}
            </span>
            <span className="ml-2 hidden font-serif-editorial italic text-white/50 md:inline">
              &ldquo;{bs.meaning}&rdquo;
            </span>
          </p>
        </div>

        <span className="hidden shrink-0 font-body text-[11px] uppercase tracking-[0.22em] text-white/70 md:inline">
          &#8377;{bs.price.toLocaleString("en-IN")}
        </span>

        <span
          data-testid="bestseller-cta"
          className="flex shrink-0 items-center gap-2 rounded-full border border-white/25 px-4 py-2 font-body text-[10px] uppercase tracking-[0.22em] text-white transition-colors duration-300 group-hover:bg-white group-hover:text-black md:px-5 md:text-[11px]"
        >
          See it
          <ArrowUpRight
            className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            strokeWidth={1.5}
          />
        </span>
      </div>
    </button>
  );
}
